import React from "react";
import { Radio, Zap, Snowflake } from "lucide-react";

const fmt = (iso) =>
  iso
    ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })
    : "—";

export const OfficialMeteocat = ({ official, snowDepth }) => {
  if (!official) {
    return (
      <div className="mb-6 text-[11px] text-white/45" data-testid="official-meteocat-missing">
        Sin dato oficial reciente de Meteocat · mostrando modelos Open-Meteo.
      </div>
    );
  }
  const l = official.lightning;
  return (
    <section className="mb-6 creep-glass p-4 flex flex-wrap gap-x-6 gap-y-3 text-xs" data-testid="official-meteocat">
      <div className="flex items-center gap-2 text-white/70">
        <Radio size={14} className="text-violet-300" />
        <span>Último dato oficial</span>
        <span className="text-white font-semibold" data-testid="official-xema-time">{fmt(official.xema_at)}</span>
        {official.xema_station && <span className="text-white/45">· {official.xema_station}</span>}
      </div>
      {snowDepth != null && (
        <div className="flex items-center gap-2 text-white/70" data-testid="official-snow-depth">
          <Snowflake size={14} className="text-violet-300" />
          Nieve medida <span className="text-white font-semibold">{Math.round(snowDepth)} cm</span>
        </div>
      )}
      {l && (
        <div className="flex items-center gap-2 text-white/70" data-testid="official-lightning">
          <Zap size={14} className={l.count > 0 ? "text-amber-300" : "text-violet-300"} />
          {l.count > 0 ? (
            <span>
              <span className="text-amber-200 font-semibold">{l.count} rayos</span> a {l.radius_km} km · el más cercano a {l.nearest_km} km
            </span>
          ) : (
            <span>Sin rayos en {l.radius_km} km (últimas {l.window_h} h)</span>
          )}
        </div>
      )}
    </section>
  );
};
